export default function DividerBlock() {
  return <hr className="content-divider" />;
}
